'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _components = require('components');

var _auth = require('redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  currentPassword: '',
  password: '',
  confirmPassword: '',
  passwordError: null
};

var UpdatePassword = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    email: state.auth.user.email,
    etag: state.user.etag,
    updating: state.auth.updatingPassword,
    updated: state.auth.passwordUpdated,
    updateError: state.auth.passwordError
  };
}, null, null, {
  withRef: true
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(UpdatePassword, _React$Component);

  function UpdatePassword() {
    (0, _classCallCheck3.default)(this, UpdatePassword);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UpdatePassword.__proto__ || (0, _getPrototypeOf2.default)(UpdatePassword)).call(this));

    _this.state = initialState;
    return _this;
  }

  (0, _createClass3.default)(UpdatePassword, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _auth.resetUpdatePassword)());
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      if (this.props.updating) return false;

      this.props.onCloseNo(reason);
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.setState(initialState);
    }
  }, {
    key: 'onCurrentPasswordChange',
    value: function onCurrentPasswordChange(password) {
      this.setState((0, _extends3.default)({}, this.state, { currentPassword: password }));
    }
  }, {
    key: 'onPasswordChange',
    value: function onPasswordChange(password) {
      this.setState((0, _extends3.default)({}, this.state, { password: password }));
    }
  }, {
    key: 'onConfirmPasswordChange',
    value: function onConfirmPasswordChange(password) {
      this.setState((0, _extends3.default)({}, this.state, { confirmPassword: password }));
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick(e) {
      e.preventDefault();
      this.props.onCloseNo('Cancelled');
    }
  }, {
    key: 'handleUpdateClick',
    value: function handleUpdateClick(e) {
      var _props = this.props,
          dispatch = _props.dispatch,
          etag = _props.etag,
          email = _props.email;


      e.preventDefault();
      e.stopPropagation();

      var _state = this.state,
          currentPassword = _state.currentPassword,
          password = _state.password,
          confirmPassword = _state.confirmPassword;


      var passwordLengthValid = password.length >= 6;
      var passwordsMatch = password === confirmPassword;

      if (!passwordLengthValid) {
        return this.setState({
          passwordError: 'Please make sure that the password is at least 6 characters long.'
        });
      }

      if (!passwordsMatch) {
        return this.setState({
          passwordError: 'Please make sure that both passwords match.'
        });
      }

      dispatch((0, _auth.updatePassword)(etag, email, currentPassword, password));
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var styles = require('./UpdatePasswordDialog.scss');

      var passwordError = this.state.passwordError;
      var _props2 = this.props,
          updating = _props2.updating,
          updated = _props2.updated,
          updateError = _props2.updateError;


      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.UpdatePasswordDialog, true), (0, _defineProperty3.default)(_classnames, styles['UpdatePasswordDialog--error'], this.state.error), _classnames));

      if (!!updateError) {
        return _react2.default.createElement(
          _components.PopupBox,
          null,
          _react2.default.createElement(
            'div',
            { className: styles['UpdatePasswordDialog__success-message'] },
            'Something went wrong. Please try again.'
          )
        );
      }

      return _react2.default.createElement(
        _components.PopupBox,
        null,
        updating ? _react2.default.createElement(_components.LoadingIndicator, { className: styles['UpdatePasswordDialog__loading-indicator'] }) : updated ? _react2.default.createElement(
          'div',
          { className: styles['UpdatePasswordDialog__success-message'] },
          'Your password has been updated!'
        ) : _react2.default.createElement(
          'form',
          { className: styles['Update__form'] },
          _react2.default.createElement(_components.TextInput, { className: styles['Update__form-input'], onChange: this.onPasswordChange.bind(this), type: 'password', title: 'New password' }),
          _react2.default.createElement(_components.TextInput, { className: styles['Update__form-input'], onChange: this.onConfirmPasswordChange.bind(this), type: 'password', title: 'Confirm password' }),
          passwordError && _react2.default.createElement(
            'p',
            { className: styles['UpdatePassword__error'] },
            passwordError
          ),
          _react2.default.createElement(
            'div',
            { className: styles['UpdatePasswordDialog__buttons'] },
            _react2.default.createElement(_components.Button, { className: styles['UpdatePasswordDialog__button'], label: 'Cancel', onClick: this.handleCancelClick.bind(this) }),
            _react2.default.createElement(_components.Button, { primary: true, alternative: true, className: styles['UpdatePasswordDialog__button'], label: 'Update', onClick: this.handleUpdateClick.bind(this) })
          )
        )
      );
    }
  }]);
  return UpdatePassword;
}(_react2.default.Component)) || _class);
exports.default = UpdatePassword;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdatePasswordDialog/UpdatePasswordDialog.jsx
// module id = 2670
// module chunks = 0